export const categoryTypes = {
    'en': [{
        title: 'Any',
        value: 'all'
    },
    {
        title: 'Condominium Projects',
        value: 'condo'
    },
    {
        title: 'House Projects',
        value: 'house'
    }],
    'th': [{
        title: 'ประเภท',
        value: 'all'
    },
    {
        title: 'คอนโด',
        value: 'condo'
    },
    {
        title: 'บ้าน',
        value: 'house'
    }],     
    'cn': [{
        title: '不限',
        value: 'all'
    },
    {
        title: '公寓',
        value: 'condo'
    },
    {
        title: '别墅',
        value: 'house'
    }],
    'ru': [{
        title: 'Любой',
        value: 'all'
    },
    {
        title: 'Квартиры',
        value: 'condo'
    },
    {
        title: 'Дома',
        value: 'house'
    }],
    'de': [{
        title: 'Beliebig',
        value: 'all'
    },
    {
        title: 'Eigentumswohnungen',
        value: 'condo'
    },
    {
        title: 'Häuser',
        value: 'house'
    }],
    'fr': [{
        title: 'N\'importe quel',
        value: 'all'
    },
    {
        title: 'Appartements',
        value: 'condo'
    },
    {
        title: 'Maisons',
        value: 'house'
    }]
}